/** @jsxImportSource @emotion/react */
import { PlainCard } from 'components/cards';
import { ShortText } from 'components/common';

import * as styles from './RemarkSection.styles';

const RemarkSection = () => (
  <PlainCard styles={styles.cardStyles}>
    <div css={styles.leftContainerStyles}>
      <ShortText>100</ShortText>
      <ShortText>teacher award</ShortText>
    </div>
    <div css={styles.rightContainerStyles}>
      <ShortText styles={styles.remarkStyles}>instructor&apos;s remarks</ShortText>
      <ShortText styles={styles.descriptionStyles}>
        Michael memiliki sifat leadership yang sangat bagus dan
        juga dapat merangkul dan membantu teman-temannya.
        Ia juga memiliki kemampuan yang baik untuk memanage waktu dengan baik.
        Dia juga dapat mengikuti semua materi di Hacktiv8 dan menyelesaikan tugas.
      </ShortText>
      <ShortText styles={styles.instructorStyles}>Hendrick Cho, Hacktiv8 Instructor</ShortText>
    </div>
  </PlainCard>
);

export default RemarkSection;
